import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import './Error.scss';

function Error({ resetErrorBoundary, errorFromBoundary }: any) {
  const { t } = useTranslation();

  const [params, setParams] = useState<string>('');
  const [searchParams] = useSearchParams();
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (errorFromBoundary) {
      console.error(errorFromBoundary);
    }
    const singleValue = searchParams.get('noInstance');
    if (!singleValue) return;
    setParams(singleValue);
  });

  const resetError = () => {
    resetErrorBoundary();
  };

  return (
    <div className="error">
      <div className="card">
        <div className="title">
          <p>\(o_o)/</p>
          {!params && <h2>{t('Error.content')}</h2>}
          {params && <h2>{t('Error.noInstance')}</h2>}
        </div>
        <Link to="/" onClick={resetError} className="link-button">{ t('Error.reload') }</Link>
      </div>
    </div>
  );
}

export default Error;
